export default __webpack_public_path__ + "assets/images/071742d3a26ec98e5c120626e019b177.png";